import React from 'react';

import { Box, Flex } from '@chakra-ui/react';

import ExpandLeftSVG from '@/assets/svg/expand-left.svg';

import SideBar, {
  SearchByKey,
} from '../companies/companiesCard/SideBar/SideBar';

import { DrawerDefault } from './drawer/DrawerDefault';
// import { useSelector } from 'react-redux';
// import contentSelectors from '@/store/content/content.selectors';
// import { useActions } from '@/hooks/useActions';

interface FilterMobileBlockProps {
  isOpen: boolean;
  onClose: () => void;
  filtersList: Record<string, unknown>;
  pathName?: string;
}

function FilterMobileBlock({ isOpen, onClose, filtersList, pathName }: FilterMobileBlockProps) {
  // const { setSearchResults } = useActions();
  // const searchResults = useSelector(contentSelectors.getSearchResults());
  return (
    <DrawerDefault
      isCloseBtn
      isOpen={isOpen}
      onClose={onClose}
      placement={'left'}
    >
      <Flex alignItems={'center'}>
        <Box onClick={onClose} cursor={'pointer'}>
          <ExpandLeftSVG />
        </Box>

        <Box display={{ base: 'block', lg: 'none' }}>
          <SearchByKey />
        </Box>
      </Flex>
      <SideBar {...{ filtersList, pathName: 'companies' }} />
    </DrawerDefault>
  );
}

export default FilterMobileBlock;
